import {HttpMutators} from './http-mutators';
import {useHttp} from './http';
import axios from 'axios';

const useTosService = () => {
    const {get, post, patch} = useHttp('/tos');

    return {
        createTos: (mutators: HttpMutators, payload: any) => post(mutators, {payload}),
        getTosList: (mutators: HttpMutators) => get(mutators),
        getTos: (mutators: HttpMutators, id: string) => get(mutators, {url: `/${id}`}),
        patchTos: (mutators: HttpMutators, id: string, payload: any) =>
            patch(mutators, {url: `/${id}`, payload}),
        getLatestPublicTos: (mutators: HttpMutators) => {
            axios.get(`${process.env.REACT_APP_API_URL}/tos/latest/public`)
                .then(res => mutators.success?.(res.data))
                .catch(err => mutators.error?.({status: err?.response?.status || 500, message: err?.message}));
        },
    };
};

export default useTosService;
